var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarpersoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.99 80.67L26.11 114.01L1.86 126.08V47.24L13.15 78.35L13.99 80.65V80.67Z",
    fill: "#1786F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.92 89.65L63.13 95.75L29.76 112.33L18.29 80.72L42.98 88.99L44.92 89.65Z",
    fill: "#1786F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35 85.2L63.13 0.0400009V91.52L44.35 85.2Z",
    fill: "#1786F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.26 28.64L67.15 35.74V0.0400009L124.26 28.64Z",
    fill: "#1786F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2 32.69V32.72V118.56L92.41 36.65L124.2 32.69Z",
    fill: "#1786F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126.12,
    height: 126.12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarpersoBlue);
export default __webpack_public_path__ + "static/media/darperso-blue.d5f1151ef8589dc40e66246fff7bd82f.svg";
export { ForwardRef as ReactComponent };